import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal__title" };
const _hoisted_2 = { class: "modifications__info" };
const _hoisted_3 = { class: "modifications__item" };
const _hoisted_4 = {
    key: 0,
    class: "modifications__article"
};
const _hoisted_5 = { class: "modifications__description" };
const _hoisted_6 = { class: "modal__footer" };
const _hoisted_7 = { class: "modifications__close" };
import { onUnmounted, ref } from 'vue';
import Modal from "@astina/paloma-common-ui/src/components/Modal.vue";
import events from '@astina/paloma-common-ui/src/services/EventBus';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartModificationsModal',
    props: {
        order: {}
    },
    emits: [
        'close'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const modifications = ref([]);
        events.$on('cart-modifications', setModifications);
        onUnmounted(() => events.$off('cart-modifications', setModifications));
        function itemName(modification) {
            const item = findItem(modification);
            return (item && item.title)
                || modification.params['item_title']
                || '[item #' + modification.itemId + ']';
        }
        function itemSku(modification) {
            const item = findItem(modification);
            return (item && item.sku)
                || modification.params['item_sku']
                || '???';
        }
        function findItem(modification) {
            return props.order.items.find(item => modification.itemId === item.id);
        }
        function setModifications(newModifications) {
            modifications.value = newModifications;
        }
        function close() {
            modifications.value = [];
            emit('close');
        }
        return (_ctx, _cache) => {
            return (modifications.value.length > 0)
                ? (_openBlock(), _createBlock(Modal, {
                    key: 0,
                    onClose: close
                }, {
                    header: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cart.modifications')), 1)
                    ]),
                    content: _withCtx(() => [
                        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('cart.modifications_info')), 1),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modifications.value, (mod, index) => {
                            return (_openBlock(), _createElementBlock("ul", {
                                key: index,
                                class: "modifications__list"
                            }, [
                                _createElementVNode("li", _hoisted_3, [
                                    (mod.itemId)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(itemName(mod)) + " (" + _toDisplayString(itemSku(mod)) + "):\n                    ", 1))
                                        : _createCommentVNode("", true),
                                    _cache[0] || (_cache[0] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('cart.modification.' + mod.code, mod.params)), 1)
                                ])
                            ]));
                        }), 128))
                    ]),
                    footer: _withCtx(() => [
                        _createElementVNode("section", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("a", {
                                    onClick: _withModifiers(close, ["prevent"]),
                                    href: "",
                                    class: "button"
                                }, _toDisplayString(_ctx.$t('acknowledge')), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
